export const FORM_ANCHOR_ID = 'business-account-form'
